import { render, staticRenderFns } from "./AuthorNewEdit.vue?vue&type=template&id=74057850&scoped=true&"
import script from "./AuthorNewEdit.vue?vue&type=script&lang=js&"
export * from "./AuthorNewEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74057850",
  null
  
)

export default component.exports